import { Reveal } from "./Reveal";
import { LeadForm } from "./LeadForm";

export const FinalCTA = () => (
  <section
    data-testid="final-cta-section"
    className="bg-ink py-24 text-cream sm:py-32"
  >
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-start gap-14 px-6 sm:px-8 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-6">
        <Reveal>
          <p className="eyebrow mb-5 !text-emerald-300">Get Started</p>
          <h2 className="text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl">
            Customers Are Already Searching. Make Sure Your Business Makes a
            Great First Impression.
          </h2>
          <p className="mt-6 max-w-lg text-base text-cream/70 sm:text-lg">
            Show me what my profile is missing — request your free, personalized
            Google Maps audit and find out exactly where your listing stands.
          </p>
          <ul className="mt-9 space-y-3.5">
            {[
              "Free, personalized audit of your listing",
              "Compared against three local competitors",
              "Five prioritized recommendations",
              "No obligation to purchase",
            ].map((item, i) => (
              <li key={i} className="flex items-center gap-3">
                <span
                  aria-hidden="true"
                  className="h-1.5 w-1.5 shrink-0 rounded-full bg-emerald-300"
                />
                <span className="font-heading text-lg font-bold">{item}</span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
      <div className="lg:col-span-6">
        <Reveal delay={0.15}>
          <LeadForm />
        </Reveal>
      </div>
    </div>
  </section>
);
